<template>
  <div>

    <z-centralized-toolbar>  
      <v-toolbar-items>
        <v-btn
          id="btn-adicionar"
          text
          small
          color="primary"
          :disabled="!$auth.temPermissao('lojas_cadastrar')"
          @click="adicionar"
        >
          <v-icon left>mdi-plus</v-icon>Adicionar
        </v-btn>
        <v-btn
          id="btAtualizar"
          text
          small
          :loading="$store.state.loading"
          @click="refresh"
        >
          <v-icon>refresh</v-icon>
          <v-tooltip bottom activator="#btAtualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
      </v-toolbar-items>

      <div style="width: 300px;" class="ml-5">
        <v-text-field
          rounded
          outlined
          single-line
          dense
          label="Pesquisar"
          autofocus
          clearable
          hide-details
          prepend-inner-icon="search"
          v-model="search"
          @keydown.enter="refresh"
          @click:clear="limparBusca"
        ></v-text-field>
      </div>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Lojas</h3>
      
      <v-card>
        <v-data-table
          :headers="headers"
          :items="lojas"
          item-key="id"
          :loading="false"
          :search="search"
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
        >
          <template v-slot:item="{ item: loja }">
            <tr>
              <td>{{ loja.id }}</td>
              <td>{{ loja.nome }}</td>
              <td>{{ loja.abreviacao }}</td>
              <td>
                <!-- <v-chip close>text</v-chip> -->
                <v-icon :color="loja.cor_primaria">mdi-circle</v-icon>
                <!-- <v-chip small :color="loja.cor_primaria">{{loja.cor_primaria}}</v-chip> -->
              </td>
              <td>
                <v-chip v-if="loja.ativa == 1" small color="green lighten-3">Ativo</v-chip>
                <v-chip v-else small color="red lighten-3">Inativo</v-chip>
                <v-chip v-if="loja.padrao == 1" class="ml-1" small color="blue lighten-3">Padrão</v-chip>
              </td>
              <td class="text-center">
                <v-btn title="Editar" icon @click="editar(loja)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <!-- <v-btn title="Excluir" icon @click="perguntarExcluir(loja)">
                  <v-icon>delete</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo-sim-nao
      ref="dialogoRemoverLoja"
      titulo="Remover loja?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      O loja <b>{{ loja.nome }}</b> será removida.
    </z-dialogo-sim-nao>

    <lojas-form ref="dialogoLojasForm"></lojas-form>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import LojasForm from "./LojasForm";
export default {
  name: "LojasLista",
  components: {
    LojasForm,
  },

  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "100px" },
        { text: "Descrição", value: "nome" },
        { text: "Abreviação", value: "abreviacao", width: "150px" },
        { text: "Cor", value: "cor_primaria", width: "100px" },
        { text: "Ativo", value: "ativo", width: "150px" },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false },
      ],
      excluindo: false,
      loja: {},
    };
  },

  created() {
    this.setTitulo("Cadastro de Lojas");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("lojas", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erroSistema("Não foi possível obter a lista de lojas.");
        throw error;
      } finally {
        this.$store.commit("LOADING_OFF");
      }
    },

    adicionar() {
      this.$store.commit("lojas/ZERAR");
      this.$refs.dialogoLojasForm.abrir();
    },

    async editar(loja) {
      try {
        await this.abrir(loja.id);
        this.$refs.dialogoLojasForm.abrir();
      } catch (error) {
        this.$eventbus.notificar("Não foi possível editar o loja.");
      } finally {
        this.LOADING_OFF();
      }
    },

    perguntarExcluir(loja) {
      this.loja = loja;
      this.$refs.dialogoRemoverLoja.abrir().then(async (response) => {
        if (response == true) {
          await this.confirmarExcluir();
        }
      });
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.loja.id);
        this.$refs.dialogoRemoverLoja.fechar();
        this.$eventbus.notificar("Lote excluído com sucesso!");
      } catch (error) {
        if (error.response) {
          this.$eventbus.erroSistema(error?.response?.data?.message);
        } else {
          this.$eventbus.erroSistema("Não foi possível excluir loja!");
        }
      } finally {
        this.excluindo = false;
      }
    },

    limparBusca() {
      this.search = "";
      this.$store.commit("lojas/SET_PAGE", 1);
      this.refresh();
    },
  },

  computed: {
    ...mapState("lojas", ["lojas", "pagination", "total_de_registros"]),

    search: {
      get() {
        return this.$store.state.lojas.search;
      },
      set(search) {
        this.$store.commit("lojas/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.lojas.pagination;
      },
      set(options) {
        this.$store.commit("lojas/UPDATE_PAGINATION", options);
      },
    },
  },

  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
